/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { checkPermission } from '../../../common/guards/can';
import PerformanceBar from './performance-bar';
import t from '../../../../data/translations';
import { dateFormat } from '../../../../utils/commonFunctions';

class PerformanceDetails extends Component {
  pointsPerPackIsVisible = () => {
    const { current_user } = this.props;
    if (current_user.attributes['user-group'] !== 'staff') {
      return true;
    }
    return checkPermission('view', 'objective_performance');
  }

  incentiveIsBaseTarget = () => {
    const { data } = this.props;
    return data.kind === 'base_target';
  }

  hasReachedTarget() {
    const { data } = this.props;
    return data.packs_sold >= data.target;
  }

  pointsPerPack() {
    const { data } = this.props;
    if (this.hasReachedTarget()) {
      return data.points_after_target;
    }
    if (this.incentiveIsBaseTarget() && data.packs_sold >= data.base_target) {
      return data.points_to_target_2;
    }
    return data.points_to_target;
  }


  checkEnded = () => {
    const { data } = this.props;
    const dateNow = Date.now();
    const checkDate = (Date.parse(data.end_date) < dateNow || dateNow < Date.parse(data.start_date));
    return checkDate;
  };

  render() {
    const { data } = this.props;

    return (
      <div className={`performance-details ${this.hasReachedTarget() ? 'reached-target' : ''}`}>
        <div className="performance-details-bar">
          <PerformanceBar
            data={data}
          />
        </div>
        <div className="performance-details-row">
          <div className="performance-details-row-images">
            {(data.product_images && data.product_images.length > 0) && (
              data.product_images.map((value, key) => {
                return (
                  <div key={key} className="performance-details-row-images-container">
                    <img src={value} />
                  </div>
                );
              })
            )}
          </div>
          {this.pointsPerPackIsVisible() && (
            <div className="points-per-pack">
              {t('pointsPerPack')} <span className="points-per-pack-number">{this.pointsPerPack()}</span>
            </div>
          )}
        </div>
        <div className="performance-details-mobile">
          {this.checkEnded() ?
            <h2>Ended</h2> :
            (data.maximum_points && <h2>{`MAX POINTS: ${data.maximum_points}`}</h2>)
          }
          {data.base_target && (
            <div className="mobile-info">
              <h2 className="word">TARGET 1</h2>
              <h2 className="number">{data.base_target}</h2>
            </div>
          )}
          {data.target && (
            <div className="mobile-info">
              <h2 className="word">TARGET 2</h2>
              <h2 className="number">{data.target}</h2>
            </div>
          )}
          <div className="mobile-info">
            <h2 className="word">ACHIEVED</h2>
            <h2 className="number">{data.packs_sold}</h2>
          </div>
          <div className="mobile-info">
            <p className="word">{t('pointsPerPack')}</p>
            <h2 className="number">{this.pointsPerPack()}</h2>
          </div>
          <div className="performance-details-mobile-images">
            {(data.product_images && data.product_images.length > 0) && (
              data.product_images.map((value, key) => {
                return (
                  <div key={key} className="performance-details-row-images-container">
                    <img src={value.image_uid} />
                  </div>
                );
              })
            )}
          </div>
        </div>
        <div className="performance-details-dates">
          <div className={ this.checkEnded() && 'ended'}>{this.checkEnded() ? 'Ended' : 'Live until'} {dateFormat(data.end_date)}</div>
          <div>Date correct as of {data.correct_to_date}</div>
        </div>
        {data.description && (
          <div className="performance-details-description">
            {data.description}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  current_user: state.viewConfig.profile
});

export default connect(mapStateToProps)(PerformanceDetails);



// WEBPACK FOOTER //
// ./src/components/store-performance/user-performances/subcomponents/performance-details.jsx